import { useLang } from "../../lib/LanguageContext";
import { IMAGES } from "../../lib/brand";
import { TrendingDown, Copy, ImageOff, Check } from "lucide-react";

export default function ProblemSolution() {
  const { t } = useLang();
  const pains = [
    { icon: TrendingDown, title: t.problem.pain1Title, body: t.problem.pain1Body },
    { icon: Copy, title: t.problem.pain2Title, body: t.problem.pain2Body },
    { icon: ImageOff, title: t.problem.pain3Title, body: t.problem.pain3Body },
  ];

  return (
    <section id="how-it-works" className="py-20 sm:py-28 bg-white border-y border-soft" data-testid="problem-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="max-w-3xl">
          <span className="text-xs font-bold uppercase tracking-widest text-brand-red">{t.problem.eyebrow}</span>
          <h2 className="mt-3 font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-ink leading-tight" data-testid="problem-title">
            {t.problem.title}
          </h2>
          <p className="mt-5 text-base sm:text-lg text-ink-muted leading-relaxed">{t.problem.subtitle}</p>
        </div>

        <div className="mt-14 grid lg:grid-cols-2 gap-6 lg:gap-10">
          {/* Pain side */}
          <div className="relative rounded-3xl p-8 sm:p-10 bg-[#FAFAFA] border border-soft" data-testid="pain-card">
            <div className="inline-block text-xs font-bold uppercase tracking-widest text-ink-muted mb-4">The Old Way</div>
            <div className="space-y-5">
              {pains.map(({ icon: Icon, title, body }) => (
                <div key={title} className="flex gap-4 p-5 rounded-2xl bg-white border border-soft">
                  <div className="shrink-0 w-11 h-11 rounded-xl bg-brand-red/10 flex items-center justify-center">
                    <Icon className="w-5 h-5 text-brand-red" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="relative inline-block">
                      <span className="font-display font-bold text-lg text-ink">{title}</span>
                      <span aria-hidden className="absolute left-0 right-0 top-1/2 h-[3px] bg-brand-red -translate-y-1/2 pointer-events-none" />
                    </div>
                    <div className="text-sm text-ink-muted mt-1.5">{body}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Solution side */}
          <div className="relative rounded-3xl p-8 sm:p-10 bg-ink text-white overflow-hidden" data-testid="solution-card">
            <div className="absolute -top-20 -right-20 w-64 h-64 rounded-full bg-brand-red/30 blur-3xl pointer-events-none" />
            <div className="relative">
              <div className="inline-block text-xs font-bold uppercase tracking-widest text-brand-orange mb-4">The AsiaCommerce Way</div>
              <h3 className="font-display font-bold text-2xl sm:text-3xl leading-tight">{t.problem.solutionTitle}</h3>
              <p className="mt-4 text-white/70 leading-relaxed">{t.problem.solutionBody}</p>

              <div className="mt-7 space-y-3">
                {[t.problem.bullet1, t.problem.bullet2, t.problem.bullet3].map((b) => (
                  <div key={b} className="flex items-center gap-3">
                    <div className="w-6 h-6 rounded-full bg-brand-orange flex items-center justify-center shrink-0">
                      <Check className="w-4 h-4 text-white" strokeWidth={3} />
                    </div>
                    <span className="text-white/90">{b}</span>
                  </div>
                ))}
              </div>

              <div className="mt-8 rounded-2xl overflow-hidden border border-white/10">
                <img src={IMAGES.warehouse} alt="Global warehouse" className="w-full h-48 object-cover" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
